import { createAsyncThunk, createSlice, nanoid } from "@reduxjs/toolkit";
import { setResultModalData, showModal, showNestedModal } from "../modal/modalSlice";
import plakaData from "../../utils/jobListPlakaData";
import { deleteSingleLoadItem, getLoadList, setLoadItemSelect } from "../loadList/loadListSlice";
import axiosInstance from "../../axios/axiosInstance";
import { toastApiError } from "../../helper/api/toastApiError";
import { beginGumrukAgcFlow } from "../gumrukAgc/gumrukAgcSlice";

const unwrapCollection = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.$values)) return value.$values;
  return [];
};

const initialState = {
  //! abd
  frameState: "equal",

  isLoadingGetDevamliAraclar: false,
  devamliAraclar: [],

  isLoadingGunlukAracList: false,
  gunlukAracList: [],

  //! bu list olacak
  yukBekleyenAracCheckedItemList: [],

  //! bu bir tane olacak
  aracBekleyenYukCheckedItem: null,

  //! araç ekleme
  vehicleData: {
    firstLastName: "",
    phoneNumber: "",
    isContinueVehicle: null,
    isReferenceDriver: null,
    devamliAraclarPlakas: [
      {
        id: nanoid(),
        plate: "",
        caseType: "",
        truckType: "",
        trailerPlate: null,
      },
    ],
  },

  //! devamlı araçlar
  dailyVehicleList: {
    vehicleStatus: "",
    vehicleCurrentLocation: "",
    timeToWaste: "",
    gunlukAracListesiCityCanGos: [],
    gunlukAracListesiRegionCanGos: [],
  },

  errorMessage: "",
  //!(ffk)
  devamliAracList: [],

  //! kasa tipi filtreleme
  kasaTypeOptions: [],

  //! form gösterme
  formActiveStep: 1,

  //! telefon ve plaka sorgulama
  controlArea: "",

  //! search işleminde kullanıcı buluyor mu
  registeredUser: null,

  //! güncellenecek sürücü id
  devamliAracItem: null,

  //! birden çok plakası varsa
  selectedPlateNumber: null,
  selectedTrailerPlateNumber: null,

  //! iş listesinden mi ekliyor yoksa devamlı araçlardan mı
  isForGunlukArac: false,

  //! güncelleme aktif/pasif
  updateActive: false,

  //! devamlı araçlar tablosu devamlı araç seçimi
  selectedDevamliArac: null,

  //! güncelleme işlemi (ffk)
  updatedDevamliArac: null,

  driverSearchData: null,
  loadingDriverSearch: false,
  errorDriverSearch: false,
  loadingAddDriver: false,
  errorAddDriver: false,
  loadingGetDriver: false,
  errorGetDriver: false,
  loadingDailyList: false,
  errorDailyList: false,
  loadingDeleteList: false,
  errorDeleteList: false,
  loadingUpdateList: false,
  errorUpdateList: false,
  loadingSms: false,
  errorSms: false,

  isLoadingJobListBireBirEslestir: false,

  vehicleClaimEligibleDrivers: [],
  isLoadingVehicleClaimEligibleDrivers: false,
  vehicleClaimEligibleDriversError: null,
  vehicleClaimEligibleDriversRequestId: null,
  lastJobListAssignmentMode: 0,

  jobListActiveActionId: 0,

  //! devamlı araç filtreleme işlemi (ffk)
  devamliAraclarFilterValues: {
    plakaSearch:"",
    phoneNumberSearch: "",
    aracTuruValue: "",
    kasaTipiValue: "",
    isDevamliArac: {
      id:1,
      value:"Tüm Araçlar",
      bool:""
    },
    isMemberOfKamyoon: {
      id:1,
      value:"Tüm Üyeler",
      bool: ""
    },
  },

  //! devamlı araç filtre temizleme
  cleanDevamliAracFilter:{
    plakaSearch:"",
    phoneNumberSearch: "",
    aracTuruValue:"",
    kasaTipiValue:"",
    isDevamliArac:"",
    isMemberOfKamyoon:"",
  },

  //! devamlı araçlarda kayıtlı araçları listeleme
  devamliAraclarKayitliArac: [],
  //! devamlı araçlarda bütün sıra listesini listeleme
  devamliAraclarSiraListesiListeleme: [],
  //! devamlı araçlarda bütün iş listesini listeleme
  devamliAraclarIsListesiListeleme: [],
  //! devamlı araç listesinden silme
  devamliAracInfoForDelete: null,

  devamliAraclarAldigiIsListeleme: [],

  //! günlük araçlar filtreleme işlemi
  gunlukAraclarFilterValues: {
    plakaSearch: "",
    aracTuruValue: "",
    cityCanGo: "",
    rateFilter: "",
  },
  //! günlük araçlar filtreleme işlemi temizle
  cleanGunlukAraclarFilterValues: {
    plakaSearch: "",
    aracTuruValue: "",
    cityCanGo: "",
    rateFilter: "",
  },

  isLoadingJobListCokluTeklifGonder: false,
  isLoadingJobListBireBirVeyaBireCokTeklifGonder: false,


  isLoadingSendMail: false,
  isUserToDevamliArac: false,

  addVehicleFromDevamliAraclar: false,

  mektupData: null,
  showNewCar:false,


  addNewDevamliDriverData: null,
  isLoadingAddNewDevamliDriver: false,
  isNewDriverStatus: false,

  //! şimdilik sadece phoneNumber
  isNewDriverData: null,

};

//! sıra listesi 
export const getGunlukAracList = createAsyncThunk("getGunlukAracList", async ({Plate = "", CityCanGo = "", TruckType = "", Star = ""}, thunkApi) => {
    try {
      const {data} = await axiosInstance.get(`/GunlukAracListesi/GetAll?Star=${Star}&Plate=${Plate}&CityCanGo=${CityCanGo}&TruckType=${TruckType}`)
      
      return data.data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})

export const getVehicleClaimEligibleDrivers = createAsyncThunk(
  "jobList/getVehicleClaimEligibleDrivers",
  async (truckId, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(
        `/Shipment/GetVehicleClaimEligibleDrivers?TruckId=${encodeURIComponent(truckId)}`,
        { signal: thunkApi.signal }
      );

      return {
        truckId,
        drivers: unwrapCollection(data?.data),
      };
    } catch (error) {
      const isAborted = error?.code === "ERR_CANCELED" || thunkApi.signal.aborted;
      const message = isAborted
        ? "İstek iptal edildi."
        : toastApiError(error, "Alt sürücüler alınamadı.");

      return thunkApi.rejectWithValue({
        truckId,
        aborted: isAborted,
        message,
      });
    }
  }
);


//! telefon sorgusu (ffk)
export const driverSearch = createAsyncThunk( "driverSearch", async (param, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get( `/DevamliAraclars/GetById?PhoneNumber=${param}`);
      if (data.data) {
        thunkApi.dispatch(setRegisteredUser(true));
      }else{
        thunkApi.dispatch(setRegisteredUser(false));
        thunkApi.dispatch(updateVehicle({ keyData: "phoneNumber", value: param}));
        thunkApi.dispatch(showModal("AddNewDevamliSurucu")) 

      }
      
      return data.data;
    } catch (error) {
      thunkApi.dispatch(setRegisteredUser(false));
      return thunkApi.rejectWithValue(error);
    }
  }
);

//! iş listesinde sıraya ekleme
export const addSiraListesi = createAsyncThunk( "addSiraListesi", async (body, thunkApi) => {
  try {
    const { data } = await axiosInstance.post( `/GunlukAracListesi/AddDevamliAracAndGunlukArac`, body);
    if (data.statusCode === 200) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({
        msg: "Başarıyla eklendi.",
        resultType: "success",
        btnText1: "Listeyi Görüntüle",
      }))
      thunkApi.dispatch(clearJobListWithoutGunlukAraclar())
      // thunkApi.dispatch(showModal(null));
    }
    else {
      thunkApi.dispatch(setErrorMessage(toastApiError(data, "Araç sıraya eklenemedi.")))
    }
    
    if (data?.data?.uyelikSozlesmesiKVKKAydinlatmaMetniAcikRzaMetni === false){
      thunkApi.dispatch(showModal("JobListInviteModal"));
    }

    return data.data;
  } catch (error) {
    const message = toastApiError(error, "Araç sıraya eklenemedi.")
    thunkApi.dispatch(setErrorMessage(message))
    return thunkApi.rejectWithValue({ message });
  }
}
);

//! sürücüler ve araçlar devamlı araç ve sıraya ekleme
export const addDevamliAracAndGunlukArac = createAsyncThunk( "addDevamliAracAndGunlukArac", async (body, thunkApi) => {
  try {
    const { data } = await axiosInstance.post( `DevamliAraclars/AddDevamliAracAndGunlukArac`, body);
    if (data.statusCode === 200) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({
        msg: "Başarıyla eklendi.",
        resultType: "success",
        btnText1: "Listeyi Görüntüle",
      }))
      thunkApi.dispatch(clearJobListWithoutGunlukAraclar())
      // thunkApi.dispatch(showModal(null));
    }
    else {
      thunkApi.dispatch(setErrorMessage(toastApiError(data, "Araç sıraya eklenemedi.")))
    }
    if (data?.data?.uyelikSozlesmesiKVKKAydinlatmaMetniAcikRzaMetni === false){
      thunkApi.dispatch(showModal("JobListInviteModal"));
    }

    

    return data.data;
  } catch (error) {
    const message = toastApiError(error, "Araç sıraya eklenemedi.")
    thunkApi.dispatch(setErrorMessage(message))
    return thunkApi.rejectWithValue({ message });
  }
}
);

//! var olan kullanıcıya plaka ekleme
export const addDevamliAracPlaka = createAsyncThunk( "addDevamliAracPlaka", async (body, thunkApi) => {
  try {
    const { data } = await axiosInstance.post( `/DevamliAraclars/AddDevamliAracPlaka`, body);
    if (data.statusCode === 200) {
      thunkApi.dispatch(showNestedModal("result"))
      thunkApi.dispatch(setResultModalData({
        msg: "Başarıyla eklendi.",
        resultType: "success",
        btnText1: "Listeyi Görüntüle",
      }))
      thunkApi.dispatch(clearVehicleRegisteredUser())
      thunkApi.dispatch(setShowNewCar(false))
    }
    else {
      toastApiError(data, "Sürücüye plaka eklenemedi.")
    }
    
    return data.data;
  } catch (error) {
    const message = toastApiError(error, "Sürücüye plaka eklenemedi.")
    return thunkApi.rejectWithValue({ message });
  }
}
);

//! devamlı araç silme
export const devamliAracDelete = createAsyncThunk( "devamliAracDelete", async (param, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.delete( `/DevamliAraclars/Delete?Id=${param}`);

      if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(clearJobListWithoutGunlukAraclar())
        thunkApi.dispatch(showModal(null));
      }

      return data.data;
    } catch (error) {
      const message = toastApiError(error, "Araç silinemedi.")
      return thunkApi.rejectWithValue({ message });
    }
  }
);

//! devamlı araç güncelleme
export const devamliAracUpdate = createAsyncThunk( "devamliAracUpdate", async (param, thunkApi) => {
    try {
      const { isContinueVehicle, isReferenceDriver, ...others } = param;
      const newParam = {
        ...others,
        isContinueVehicle: isContinueVehicle.bool !== undefined ? isContinueVehicle.bool : isContinueVehicle,
        isReferenceDriver: isReferenceDriver.bool !== undefined ? isReferenceDriver.bool : isReferenceDriver,
      };
      const { data } = await axiosInstance.post( `/DevamliAraclars/Update`, newParam);
      if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarıyla güncellendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
        thunkApi.dispatch(clearJobListWithoutGunlukAraclar())
      }
      else {
        toastApiError(data, "Sürücü güncellenemedi.")
      }
      return data.data;
    } catch (error) {
      const message = toastApiError(error, "Sürücü güncellenemedi.")
      return thunkApi.rejectWithValue({ message });
    }
  }
);

//! sms gönderme (ffk)
export const sendInviteSms = createAsyncThunk( "sendInviteSms", async (param, thunkApi) => {
    try {

      const { data } = await axiosInstance.post( `/DevamliAraclars/SendSMS`, param);

      if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("JobSmsModal"));
      }

      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

//! günlük sıradaki araçları silme
export const deleteGunlukArac = createAsyncThunk( "deleteGunlukArac", async (param, thunkApi) => {
    try {

      const { data } = await axiosInstance.post(`/GunlukAracListesi/Delete?Id=${param}`, "_");

      if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarıyla silindi.",
            routePath: "/yuk-islemleri/is-listesi",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
      } else {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
            routePath: "/yuk-islemleri/is-listesi",
            resultType: "error",
            btnText1: "Listeyi Görüntüle",
          })
        );
      }

      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

// //! devamlı araçlar filtre
export const devamliAraclarFiltre = createAsyncThunk("devamliAraclarFiltre",async ({ plakaSearch = "", phoneNumberSearch = "", aracTuruValue = "", kasaTipiValue = "", isDevamliArac = "", isMemberOfKamyoon = "",},  thunkApi) => {
    try {

      const { data } = await axiosInstance.get(`/DevamliAraclars/GetAllFilter?PhoneNumber=${phoneNumberSearch}&Plate=${plakaSearch}&CaseType=${kasaTipiValue}&TruckType=${aracTuruValue}&IsContinueVehicle=${isDevamliArac}&IsKamyoonMember=${isMemberOfKamyoon}`);
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

//! iki tablodan da bir tane seçildiğinde teklif göndermek için
export const sendMail = createAsyncThunk("sendMail", async(fileData, thunkApi) => {
  try{
    
    const myFile = new FormData();
    myFile.append('File',fileData.file, "tasima_senedi.pdf");
    myFile.append('Email',fileData.mail);
    myFile.append('FileName',fileData.fileName);
    myFile.append('YukId',fileData.yukId);
    myFile.append('AracId',fileData.aracId);
    myFile.append('GunlukAracId',fileData.gunlukAracId);

    
    
    const {data} = await axiosInstance.post(`/Shipment/SendTasimaSenediWithMail`,myFile)
    if (data.statusCode === 200 && !fileData?.fromShipment) {
      thunkApi.dispatch(showNestedModal("result"));
      thunkApi.dispatch(setLoadItemSelect(fileData.yukId))
      thunkApi.dispatch(setResultModalData({ msg: "Mail başarıyla gönderildi.", routePath:"yuklemede", resultType: "success", btnText1: "Harika!",}));
    }
    else if(data.statusCode === 200 && fileData?.fromShipment){
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Mail başarıyla gönderildi.", resultType: "success", btnText1: "Harika!",}));
    }
    else{
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ 
        msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", 
        resultType: "error", 
        btnText1: "Listeye Dön",
      }));
    }
    return data
  }catch(error){
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(setResultModalData({ 
      msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", 
      resultType: "error", 
      btnText1: "Listeye Dön",
    }));
    return thunkApi.rejectWithValue(error)
  }
})

//! en son bunu kaydetmede kaldın
//! iki tablodan da bir tane seçildiğinde direk eşleştirmek için
export const jobListBireBirEslestir = createAsyncThunk( "jobListBireBirEslestir", async (dataIds, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post(`/GunlukAracListesi/AddShipment`, dataIds);
      if (data.statusCode === 200) {
        const responseData = data?.data ?? {};
        const requiresGumrukApproval =
          responseData.requiresGumrukAgcApproval ??
          responseData.RequiresGumrukAgcApproval ??
          false;
        const operationId =
          responseData.gumrukAgcOperationId ?? responseData.GumrukAgcOperationId;
        const shipmentId =
          responseData.shipmentId ??
          responseData.ShipmentId ??
          responseData.yukId ??
          dataIds.yukId;

        if (requiresGumrukApproval && operationId) {
          const jobListState = thunkApi.getState().jobList;
          thunkApi.dispatch(beginGumrukAgcFlow({
            operationId,
            shipmentId,
            assignmentContext: {
              loadData: jobListState.aracBekleyenYukCheckedItem,
              vehicleData: jobListState.yukBekleyenAracCheckedItemList[0] ?? null,
              assignmentMode: jobListState.lastJobListAssignmentMode,
            },
          }));
          thunkApi.dispatch(showModal("gumrukAgc"));
        } else {
          if (requiresGumrukApproval && !operationId) {
            toastApiError(data, "Gümrük operasyon kimliği alınamadı.");
          }
          thunkApi.dispatch(showModal("jobListBirebirEslestirResult"));
        }

        thunkApi.dispatch(deleteSingleLoadItem(shipmentId));
        // {dispatch(showModal("showMektup"));dispatch(getMektupData({yukData: aracBekleyenYukCheckedItem, aracData: yukBekleyenAracCheckedItemList[0]}))}
      }
      else {
        toastApiError(data, "Araç ve yük eşleştirilemedi.")
      }
      return data;
    } catch (error) {
      const { gunlukAraclarFilterValues } = thunkApi.getState().jobList;
      const { plakaSearch, aracTuruValue, cityCanGo, rateFilter } = gunlukAraclarFilterValues;
      const message = toastApiError(error, "Araç ve yük eşleştirilemedi.");

      // Rezervasyon ve eş zamanlı veri değişikliği hatalarında doğruluk kaynağı API'dir.
      thunkApi.dispatch(getGunlukAracList({
        Plate: plakaSearch || "",
        CityCanGo: cityCanGo?.value || "",
        TruckType: aracTuruValue?.name || "",
        Star: rateFilter?.id || "",
      }));
      thunkApi.dispatch(getLoadList({ currentPage: 1, isParsiyel: 0 }));
      return thunkApi.rejectWithValue({ message });
    }
  }
);


//! iki tablodan da bir tane seçildiğinde teklif göndermek için
export const jobListBireBirVeyaBireCokTeklifGonder = createAsyncThunk("jobListBireBirVeyaBireCokTeklifGonder", async (dataIds, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post(`/GunlukAracListesi/AddAspiredLoadByLoadOwner`, dataIds);
      if(data.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Teklif sürücüye başarıyla gönderildi.", routePath: "/yuk-islemleri/is-listesi", resultType: "success", btnText1: "Listeyi Görüntüle"}))
      }
      else{
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", routePath: "/yuk-islemleri/is-listesi", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      }
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

//! çoklu eşleştirmeler için
export const jobListCokluTeklifGonder = createAsyncThunk("jobListCokluTeklifGonder", async(dataList, thunkApi) => {
  try{
    
    const {data} = await axiosInstance.post(`/GunlukAracListesi/sendCokluTeklifJobList`,dataList)
    if(data.statusCode === 200){
      thunkApi.dispatch(showModal("result"))
      thunkApi.dispatch(setResultModalData({msg: "Teklifler başarıyla gönderildi.", routePath: "/yuk-islemleri/is-listesi", resultType: "success", btnText1: "Listeyi Görüntüle"}))
    }
    else{
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", routePath: "/yuk-islemleri/is-listesi", resultType: "error", btnText1: "Listeyi Görüntüle"}))
    }
    return data
  }catch(error){
    const message = toastApiError(error, "Teklif gönderilemedi.")
    return thunkApi.rejectWithValue({ message })
  }
})


//! *****************************************************************************************************************

export const addNewDevamliDriver = createAsyncThunk("addNewDevamliDriver", async({formData, phoneNumber}, thunkApi) => {
  try{
    
    const {data} = await axiosInstance.post(`/DevamliAraclars/CreateNewDriverFromClient`, formData)

    if(data.statusCode === 0){
      thunkApi.dispatch(showModal("addAracQuestion"))
    }
    else{
        const message = toastApiError(data, "Sürücü eklenemedi.")
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: message, resultType: "error", btnText1: "Tamam"}))
    }
    return data.statusCode === 0 ? phoneNumber : null
  }catch(error){
    const message = toastApiError(error, "Sürücü eklenemedi.")
    return thunkApi.rejectWithValue({ message })
  }
})

export const addNewDevamliArac = createAsyncThunk("addNewDevamliArac", async(formData, thunkApi) => {
  try{

    const {data} = await axiosInstance.post(`/TruckTrailer/AddTruckTrailerFromClientV2`, formData)

    if(data.statusCode === 200){
      thunkApi.dispatch(showModal("result"))
      thunkApi.dispatch(setResultModalData({msg: "Araç ekleme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Harika"}))
    }
    else{
        const message = toastApiError(data, "Araç eklenemedi.")
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: message, resultType: "error", btnText1: "Tamam"}))
    }
    return data
  }catch(error){
    const message = toastApiError(error, "Araç eklenemedi.")
    return thunkApi.rejectWithValue({ message })
  }
})




const jobListSlice = createSlice({
  name: "jobList",
  initialState,
  reducers: {
    //! abd
    handleFrameState: (state, action) => {
      state.frameState = action.payload;
    },

    //! abd
    setYukBekleyenAracCheckedItemList: (state, action) => {
      const item = action.payload;
      const idList = state.yukBekleyenAracCheckedItemList.map((item) => item.id);
      if (idList.includes(item.id)) {
        state.yukBekleyenAracCheckedItemList = state.yukBekleyenAracCheckedItemList.filter((innerItem) => innerItem.id !== item.id);
      } else {
        state.yukBekleyenAracCheckedItemList = [ ...state.yukBekleyenAracCheckedItemList, item];
      }
    },

    //! bu jobList de hangi butonların gözükeceği
    setJobListActiveActionId: (state, action) => {
      state.jobListActiveActionId = action.payload;
    },

    //! abd
    setAracBekleyenYukCheckedItem: (state, action) => {
      state.aracBekleyenYukCheckedItem = action.payload;
    },

    clearCheckedData:(state) => {
      state.aracBekleyenYukCheckedItem = null
      state.yukBekleyenAracCheckedItemList = []
    },

    resetVehicleClaimEligibleDrivers: (state) => {
      state.vehicleClaimEligibleDrivers = [];
      state.isLoadingVehicleClaimEligibleDrivers = false;
      state.vehicleClaimEligibleDriversError = null;
      state.vehicleClaimEligibleDriversRequestId = null;
    },

    //! abd
    getMektupData: (state, action) => {
      state.mektupData = action.payload;
    },

    restoreGumrukAssignmentContext: (state, action) => {
      const { loadData, vehicleData, assignmentMode } = action.payload ?? {};
      state.aracBekleyenYukCheckedItem = loadData ?? state.aracBekleyenYukCheckedItem;
      state.yukBekleyenAracCheckedItemList = vehicleData
        ? [vehicleData]
        : state.yukBekleyenAracCheckedItemList;
      state.lastJobListAssignmentMode = assignmentMode ?? state.lastJobListAssignmentMode;
    },

    //! devamlı araçlara ekleme için input güncelleme (ffk)
    updateVehicle: (state, action) => {
      const { keyData, value } = action.payload;
      
      state.vehicleData = {
        ...state.vehicleData,
        [keyData]: value,
      };
    },

    //! sıraya ekleme için input güncelleme (ffk)
    updateDailyVehicleList: (state, action) => {
      const { keyData, value } = action.payload;
      state.dailyVehicleList = {
        ...state.dailyVehicleList,
        [keyData]: value,
      };
    },

    //! gunluk araçlar filtreleme
    setGunlukAraclarValues: (state, action) => {
      const { keyData, value } = action.payload;
      state.gunlukAraclarFilterValues = {
        ...state.gunlukAraclarFilterValues,
        [keyData]: value,
      };
    },

    setCleanGunlukAraclarFilterValues: (state) => {
      state.gunlukAraclarFilterValues = state.cleanGunlukAraclarFilterValues;
    },

    //!(ffk)
    addDevamliAraclarPlaka: (state, action) => {
      const newItem = { ...plakaData, id: nanoid() };
      state.vehicleData = {
        ...state.vehicleData,
        devamliAraclarPlakas: [
          ...state.vehicleData.devamliAraclarPlakas,
          newItem,
        ],
      };
    },

    //! kayıtlı kullanıcıya fazladan araç eklediğimiz alan
    addVehicleRegisteredUser: (state, action) => {
      state.driverSearchData = {...state.driverSearchData, devamliAraclarPlakas: [...state.driverSearchData.devamliAraclarPlakas, action.payload ]}
    },
    deleteVehicleRegisteredUser: (state, action) => {
      // state.driverSearchData = {...state.driverSearchData, devamliAraclarPlakas: state.driverSearchData.devamliAraclarPlakas.filter((item) => {return item?.plate !== action.payload.plate })}
      state.vehicleData = {...state.vehicleData, devamliAraclarPlakas: state.vehicleData.devamliAraclarPlakas.map((item) => {
        if(item.id === action.payload.id){
          return {...item, plate: "", caseType: "", truckType: "",}
        }else{
          return item
        }
        
      })}
    },
    clearVehicleRegisteredUser: (state, action) => {
      state.vehicleData = {
        firstLastName: "",
        phoneNumber: "",
        isContinueVehicle: null,
        isReferenceDriver: null,
        devamliAraclarPlakas: [
          {
            id: nanoid(),
            plate: "",
            caseType: "",
            truckType: "",
          },
        ],
      }
    },

    //! delete devamlı araçlar plaka
    deleteDevamliAraclarPlaka: (state, action) => {
      state.vehicleData = {...state.vehicleData, devamliAraclarPlakas: state.vehicleData.devamliAraclarPlakas.filter((item) => {
        return item.id !== action.payload.id
      })}
      
      const newTruckPlate = state.selectedPlateNumber?.id === action?.payload?.id ? null : state.selectedPlateNumber
      const newTrailerPlate = state.selectedTrailerPlateNumber?.id === action?.payload?.id ? null : state.selectedTrailerPlateNumber
      state.selectedPlateNumber = newTruckPlate
      state.selectedTrailerPlateNumber = newTrailerPlate
    },

    //!(ffk)
    updateDevamliAraclarPlaka: (state, action) => {
      state.vehicleData = {
        ...state.vehicleData,
        devamliAraclarPlakas: state.vehicleData.devamliAraclarPlakas.map(
          (item) => {
            if (item.id === action.payload.id) {
              return { ...item, ...action.payload };
            } else {
              return item;
            }
          }
        ),
      };
    },

    //! ffk
    updateKasaTypeOptions: (state, action) => {
      state.kasaTypeOptions = action.payload;
    },

    //! gereksiz silinebilir (ffk)
    setFormActiveStep: (state, action) => {
      state.formActiveStep = action.payload;
    },

    //! plakaya göre sorgulama (ffk)
    setControlArea: (state, action) => {
      state.controlArea = action.payload;
    },

    //! devamlı araçlar ile sıraya eklenecek aracı eşlemek için (ffk)
    getDevamliAracItem: (state, action) => {
      state.devamliAracItem = action.payload;
    },

    //! çoklu plakalarda seçim
    setSelectedPlateNumber: (state, action) => {
      state.selectedPlateNumber = action.payload;
    },
    setSelectedTrailerPlateNumber: (state, action) => {
      state.selectedTrailerPlateNumber = action.payload;
    },
    //!(ffk)
    setUpdateActive: (state, action) => {
      state.updateActive = !state.updateActive;
    },

    //! devamlı araç güncelleme (ffk)
    setUpdatedDevamliArac: (state, action) => {
      state.selectedDevamliArac = { ...state.selectedDevamliArac, ...action.payload};
    },

    addUpdatedDevamliAraclarPlaka: (state, action) => {
      const newItem = { ...plakaData, id: nanoid() };
      state.updatedDevamliArac = {
        ...state.updatedDevamliArac,
        devamliAraclarPlakas: [
          ...state.updatedDevamliArac.devamliAraclarPlakas,
          newItem,
        ],
      };
    },

    //!(ffk)
    setUpdatedDevamliAracPlaka: (state, action) => {
      state.updatedDevamliArac = {
        ...state.updatedDevamliArac,
        devamliAraclarPlakas: state.updatedDevamliArac.devamliAraclarPlakas.map(
          (item) => {
            if (item.id === action.payload.id) {
              return { ...item, ...action.payload };
            } else {
              return item;
            }
          }
        ),
      };
    },
    //!(ffk)
    setAllDataForDevamliArac: (state, action) => {
      state.updatedDevamliArac = action.payload;
    },

    //! çoklu şehir seçimi (ffk)
    multipleCitySelect: (state, action) => {
      const ids = state.dailyVehicleList.gunlukAracListesiCityCanGos.map((item) => item.id);
      if (ids.includes(action.payload.id)) {
        state.dailyVehicleList.gunlukAracListesiCityCanGos = state.dailyVehicleList.gunlukAracListesiCityCanGos.filter((item) => item.id !== action.payload.id );
      } else {
        state.dailyVehicleList.gunlukAracListesiCityCanGos = [ ...state.dailyVehicleList.gunlukAracListesiCityCanGos, action.payload,];
      }
    },

    multipleCitySelectArray: (state, action) => {
      const newCityList =  action.payload.filter((item) => {
        return !state.dailyVehicleList.gunlukAracListesiCityCanGos.includes(item)
      })

      return {
        ...state,
        dailyVehicleList: {
          ...state.dailyVehicleList,
          gunlukAracListesiCityCanGos: newCityList
        }
      };
    },

    //! çoklu bölge seçimi (ffk)
    multipleRegionSelect: (state, action) => {
      const ids = state.dailyVehicleList.gunlukAracListesiRegionCanGos.map(
        (item) => item.value
      );
      if (ids.includes(action.payload.value)) {
        state.dailyVehicleList.gunlukAracListesiRegionCanGos =
          state.dailyVehicleList.gunlukAracListesiRegionCanGos.filter(
            (item) => item.value !== action.payload.value
          );
      } else {
        state.dailyVehicleList.gunlukAracListesiRegionCanGos = [
          ...state.dailyVehicleList.gunlukAracListesiRegionCanGos,
          action.payload,
        ];
      }
    },

    //! çoklu ehliyet seçimi (ffk)
    multipleEhliyetSelect: (state, action) => {
      const ids = state.vehicleData.devamliAraclarEhliyet.map(
        (item) => item.id
      );
      if (ids?.includes(action.payload.id)) {
        state.vehicleData.devamliAraclarEhliyet =
          state.vehicleData.devamliAraclarEhliyet.filter(
            (item) => item.id !== action.payload.id
          );
      } else {
        state.vehicleData.devamliAraclarEhliyet = [
          ...state.vehicleData.devamliAraclarEhliyet,
          action.payload,
        ];
      }
    },

    //! çoklu SRC seçimi (ffk)
    multipleSrcSelect: (state, action) => {
      const ids = state.vehicleData.devamliAraclarSrcBelgesi.map(
        (item) => item.id
      );
      if (ids?.includes(action.payload.id)) {
        state.vehicleData.devamliAraclarSrcBelgesi =
          state.vehicleData.devamliAraclarSrcBelgesi.filter(
            (item) => item.id !== action.payload.id
          );
      } else {
        state.vehicleData.devamliAraclarSrcBelgesi = [
          ...state.vehicleData.devamliAraclarSrcBelgesi,
          action.payload,
        ];
      }
    },
    
    multipleEhliyetSelectUpdate: (state, action) => {
      const devamliAraclarEhliyet = state?.updatedDevamliArac?.devamliAraclarEhliyet || []

      const ids = devamliAraclarEhliyet?.map(
        (item) => item.id
      );

      if (ids?.includes(action.payload.id)) {
        state.updatedDevamliArac = {
          ...state.updatedDevamliArac,
          devamliAraclarEhliyet:
            devamliAraclarEhliyet?.filter(
              (item) => item.id !== action.payload.id
            ),
        };
      } else {
        state.updatedDevamliArac = {
          ...state.updatedDevamliArac,
          devamliAraclarEhliyet: [
            ...devamliAraclarEhliyet,
            action.payload,
          ],
        };
      }
    },

    multipleSrcSelectUpdate: (state, action) => {
      const devamliAraclarSrcBelgesi = state?.updatedDevamliArac?.devamliAraclarSrcBelgesi || [];
    
      const ids = devamliAraclarSrcBelgesi.map(item => item.id);
    
      if (ids.includes(action.payload.id)) {
        state.updatedDevamliArac = {
          ...state.updatedDevamliArac,
          devamliAraclarSrcBelgesi: devamliAraclarSrcBelgesi.filter(item => item.id !== action.payload.id),
        };
      } else {
        state.updatedDevamliArac = {
          ...state.updatedDevamliArac,
          devamliAraclarSrcBelgesi: [...devamliAraclarSrcBelgesi, action.payload],
        };
      }
    },

    //! kontrol işleminin durumunu kontrol ediyor (ffk)
    setRegisteredUser: (state, action) => {
      state.registeredUser = action.payload;
    },

    //! devamlı araçlar ******

    //! select devamlı araç (ffk)
    setSelectedDevamliArac: (state, action) => {
      state.selectedDevamliArac = action.payload;
    },

    //! devamlı araçlar filtre alanı
    setDevamliAraclarValues: (state, action) => {
      const { keyData, value } = action.payload;
      state.devamliAraclarFilterValues = {
        ...state.devamliAraclarFilterValues,
        [keyData]: value,
      };
    },

    //! devamlı aracın kayıtlı araçları (ffk)
    setDevamliAraclarKayitliArac: (state, action) => {
      state.devamliAraclarKayitliArac = action.payload;
    },
    //! devamlı aracın kayıtlı sıra listesi (ffk)
    setDevamliAraclarSiraListesiListeleme: (state, action) => {
      state.devamliAraclarSiraListesiListeleme = action.payload;
    },
    //! devamlı aracın kayıtlı iş listesi (ffk)
    setDevamliAraclarIsListesiListeleme: (state, action) => {
      state.devamliAraclarIsListesiListeleme = action.payload;
    },

    //! devamlı aracın kayıtlı iş listesi (ffk)
    setDevamliAraclarAldigiIsListeleme: (state, action) => {
      state.devamliAraclarAldigiIsListeleme = action.payload;
    },
    //! devamli arac filter temizleme
    setCleanDevamliAracFilter: (state, action) => {
      state.devamliAraclarFilterValues = state.cleanDevamliAracFilter;
    },

    setDevamliAracInfoForDelete: (state, action) => {
      state.devamliAracInfoForDelete = action.payload;
    },

    setIsUserToDevamliArac: (state, action) => {
      state.isUserToDevamliArac = action.payload
    },

    setAddVehicleFromDevamliAraclar: (state, action) => {
      state.addVehicleFromDevamliAraclar = action.payload
    },

    setShowNewCar: (state, action) => {
      state.showNewCar = !state.showNewCar
    },

    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload
    },
    
    setIsForGunlukArac: (state, action) => {
      state.isForGunlukArac = action.payload
    },

    //!(ffk)
    clearJobListWithoutGunlukAraclar: (state,action) => {
      const gunlukAracList = state.gunlukAracList
      // const selectedPlateNumber = state.selectedPlateNumber
      const devamliAracItem = state.devamliAracItem
      const devamliAracList = state.devamliAracList
      const frameState = state.frameState
      const jobListActiveActionId = state.jobListActiveActionId
      return {...initialState, gunlukAracList, devamliAracItem, frameState, jobListActiveActionId, devamliAracList};
    },

    clearJobListWithoutGunlukAraclarAndSearch: (state,action) => {
      const gunlukAracList = state.gunlukAracList
      // const selectedPlateNumber = state.selectedPlateNumber
      const controlArea = state.controlArea
      const devamliAracItem = state.devamliAracItem
      const devamliAracList = state.devamliAracList
      const frameState = state.frameState
      const jobListActiveActionId = state.jobListActiveActionId
      return {...initialState, gunlukAracList, devamliAracItem, frameState, jobListActiveActionId, devamliAracList, controlArea};
    },
  },

  extraReducers: (builder) => {
    builder

      //!abd
      .addCase(getGunlukAracList.pending, (state) => {
        state.isLoadingGunlukAracList = true;
      })
      .addCase(getGunlukAracList.fulfilled, (state, action)=> {
        state.isLoadingGunlukAracList = false
        state.gunlukAracList = action?.payload?.$values?.map(item => {
            return {...item, gunlukAracListesiCityCanGos: item?.gunlukAracListesiCityCanGos?.$values, gunlukAracListesiRegionCanGos:item?.gunlukAracListesiRegionCanGos?.$values, sendedLoadIdNotifications: item?.sendedLoadIdNotifications?.$values.map(innerItem => {
            return {loadId:innerItem.loadId, sendedDate:innerItem.sendedDate}
            }
          )}
        })
      })
      .addCase(getGunlukAracList.rejected, (state, action)=> {
        state.isLoadingGunlukAracList = false
      })

      //!(ffk)
      .addCase(driverSearch.pending, (state) => {
        state.loadingDriverSearch = true;
      })
      //!(ffk)
      .addCase(driverSearch.fulfilled, (state, action) => {
        state.loadingDriverSearch = false;
        
        state.driverSearchData = {
          ...action.payload,
          devamliAraclarPlakas: {
            trucks: action?.payload?.devamliAraclarPlakas.trucks.$values,
            trailer: action?.payload?.devamliAraclarPlakas.trailers.$values
          },
          
        };
      })
      //!(ffk)
      .addCase(driverSearch.rejected, (state, action) => {
        state.loadingDriverSearch = false;
        state.errorDriverSearch = true;
      })

      //! devamlı araçlar
      
      .addCase(addDevamliAracAndGunlukArac.pending, (state) => {
        state.loadingAddDriver = true;
      })
      //!(ffk)
      .addCase(addDevamliAracAndGunlukArac.fulfilled, (state, action) => {
        state.loadingAddDriver = false;

        //! devamlı araç bilgisi varsa onu da ekliyoruz
        const devamliAracResponse = {
          ...action.payload, 
          devamliAraclarPlakas: action?.payload?.devamliAraclarPlakas?.$values,  
          personalLoads: action?.payload?.personalLoads?.$values,
          allGunlukAracListesi: action?.payload?.allGunlukAracListesi?.$values?.map((item) => {
            return { 
              ...item,
              gunlukAracListesiCityCanGos:item?.gunlukAracListesiCityCanGos?.$values,
              gunlukAracListesiRegionCanGos:item?.gunlukAracListesiRegionCanGos?.$values,
            };
          }),
          filterGunlukAracListesi: action?.payload?.filterGunlukAracListesi?.$values?.map((item) => {
            return {
              ...item,
              gunlukAracListesiCityCanGos:item?.gunlukAracListesiCityCanGos?.$values,
              gunlukAracListesiRegionCanGos:item?.gunlukAracListesiRegionCanGos?.$values,
            };
          })
        }
        state.devamliAracList = [...state.devamliAracList, devamliAracResponse]
      })
      //!(ffk)
      .addCase(addDevamliAracAndGunlukArac.rejected, (state, action) => {
        state.loadingAddDriver = false;
        state.errorAddDriver = true;
      })

      
      //!(ffk) sıra listesi
      .addCase(addSiraListesi.pending, (state) => {
        state.loadingAddDriver = true;
      })
      //!(ffk)
      .addCase(addSiraListesi.fulfilled, (state, action) => {
        state.loadingAddDriver = false;
        const gunlukAraclarResponse = {
            ...action.payload,
            gunlukAracListesiCityCanGos: action?.payload?.gunlukAracListesiCityCanGos?.$values,
            gunlukAracListesiRegionCanGos: action?.payload?.gunlukAracListesiRegionCanGos?.$values,
            sendedLoadIdNotifications: action?.payload?.sendedLoadIdNotifications?.$values
        };
        state.gunlukAracList = [...state.gunlukAracList, gunlukAraclarResponse];
      })
      //!(ffk)
      .addCase(addSiraListesi.rejected, (state, action) => {
        state.loadingAddDriver = false;
        state.errorAddDriver = true;
      })

      //!(ffk)
      .addCase(addDevamliAracPlaka.pending, (state) => {
        state.loadingAddDriver = true;
      })
      //!(ffk)
      .addCase(addDevamliAracPlaka.fulfilled, (state, action) => {
        state.loadingAddDriver = false;
        state.driverSearchData = {
          ...action.payload,
          devamliAraclarPlakas: {
            trucks: action?.payload?.devamliAraclarPlakas.trucks.$values,
            trailer: action?.payload?.devamliAraclarPlakas.trailers.$values
          },
        };
      })
      //!(ffk)
      .addCase(addDevamliAracPlaka.rejected, (state, action) => {
        state.loadingAddDriver = false;
        state.errorAddDriver = true;
      })

      
      
      //!(ffk)
      .addCase(devamliAraclarFiltre.pending, (state) => {
        state.loadingGetDriver = true;
      })
      //!(ffk)
      .addCase(devamliAraclarFiltre.fulfilled, (state, action) => {
        state.loadingGetDriver = false;
        state.devamliAracList = action.payload.$values.map((item) => {
          return {
            ...item,
            devamliAraclarPlakas: item?.devamliAraclarPlakas?.$values,
            devamliAraclarEhliyet: item?.devamliAraclarEhliyet?.$values,
            devamliAraclarSrcBelgesi: item?.devamliAraclarSrcBelgesi?.$values,
            personalLoads: item?.personalLoads?.$values,
            allGunlukAracListesi: item?.allGunlukAracListesi?.$values?.map(
              (item) => {
                return {
                  ...item,
                  gunlukAracListesiCityCanGos:item?.gunlukAracListesiCityCanGos?.$values,
                  gunlukAracListesiRegionCanGos:item?.gunlukAracListesiRegionCanGos?.$values,
                };
              }
            ),
            filterGunlukAracListesi:
              item?.filterGunlukAracListesi?.$values?.map((item) => {
                return {
                  ...item,
                  gunlukAracListesiCityCanGos:item?.gunlukAracListesiCityCanGos?.$values,
                  gunlukAracListesiRegionCanGos:item?.gunlukAracListesiRegionCanGos?.$values,
                };
              }),
          };
        });
      })
      //!(ffk)
      .addCase(devamliAraclarFiltre.rejected, (state, action) => {
        state.loadingGetDriver = false;
        state.errorGetDriver = true;
      })
      
      //!(ffk)
      .addCase(devamliAracDelete.pending, (state) => {
        state.loadingDeleteList = true;
      })
      //!(ffk)
      .addCase(devamliAracDelete.fulfilled, (state, action) => {
        state.loadingDeleteList = false;
        state.devamliAracList = state.devamliAracList.filter(
          (item) => item.id !== action.payload.id
        );
      })
      //!(ffk)
      .addCase(devamliAracDelete.rejected, (state, action) => {
        state.loadingDeleteList = false;
        state.errorDeleteList = true;
      })
      //!(ffk)
      .addCase(devamliAracUpdate.pending, (state) => {
        state.loadingUpdateList = true;
      })
      //!(ffk)
      .addCase(devamliAracUpdate.fulfilled, (state, action) => {
        state.loadingUpdateList = false;
        
        state.devamliAracList = state.devamliAracList?.map((item) => {
          const shouldUpdate = item.id === action.payload.id;
          
          if (shouldUpdate) {
            return {
              ...action.payload,
              devamliAraclarPlakas: action.payload?.devamliAraclarPlakas?.$values || item.devamliAraclarPlakas, 
              devamliAraclarEhliyet: action.payload?.devamliAraclarEhliyet?.$values || item.devamliAraclarEhliyet, 
              devamliAraclarSrcBelgesi: action.payload?.devamliAraclarSrcBelgesi?.$values || item.devamliAraclarSrcBelgesi,
              allGunlukAracListesi: action.payload?.allGunlukAracListesi?.$values || item.allGunlukAracListesi,
              filterGunlukAracListesi: action.payload?.filterGunlukAracListesi?.$values || item.filterGunlukAracListesi,
              personalLoads: action.payload?.personalLoads?.$values || item.personalLoads
            };
          } else {
            return item;
          }
        });
        
      })
      //!(ffk)
      .addCase(devamliAracUpdate.rejected, (state) => {
        state.loadingUpdateList = false;
        state.errorUpdateList = true;
      })
      //!(ffk)
      .addCase(sendInviteSms.pending, (state) => {
        state.loadingSms = true;
      })
      //!(ffk)
      .addCase(sendInviteSms.fulfilled, (state, action) => {
        state.loadingSms = false;
      })
      //!(ffk)
      .addCase(sendInviteSms.rejected, (state) => {
        state.loadingSms = false;
        state.errorSms = true;
      })

      //!(ffk)
      .addCase(deleteGunlukArac.pending, (state) => {
        state.loadingDeleteList = true;
      })
      //!(ffk)
      .addCase(deleteGunlukArac.fulfilled, (state, action) => {
        state.loadingDeleteList = false;
        state.gunlukAracList = state.gunlukAracList.filter(
          (item) => item.id !== action.payload.id
        );
      })
      //!(ffk)
      .addCase(deleteGunlukArac.rejected, (state, action) => {
        state.loadingDeleteList = false;
        state.errorDeleteList = true;
      })

    .addCase(getVehicleClaimEligibleDrivers.pending, (state, action) => {
      state.isLoadingVehicleClaimEligibleDrivers = true;
      state.vehicleClaimEligibleDrivers = [];
      state.vehicleClaimEligibleDriversError = null;
      state.vehicleClaimEligibleDriversRequestId = action.meta.requestId;
    })
    .addCase(getVehicleClaimEligibleDrivers.fulfilled, (state, action) => {
      if (state.vehicleClaimEligibleDriversRequestId !== action.meta.requestId) return;

      state.isLoadingVehicleClaimEligibleDrivers = false;
      state.vehicleClaimEligibleDrivers = action.payload.drivers;
      state.vehicleClaimEligibleDriversRequestId = null;
    })
    .addCase(getVehicleClaimEligibleDrivers.rejected, (state, action) => {
      if (state.vehicleClaimEligibleDriversRequestId !== action.meta.requestId) return;

      state.isLoadingVehicleClaimEligibleDrivers = false;
      state.vehicleClaimEligibleDrivers = [];
      state.vehicleClaimEligibleDriversError = action.payload?.aborted
        ? null
        : action.payload?.message || "Alt sürücüler alınamadı.";
      state.vehicleClaimEligibleDriversRequestId = null;
    })

    .addCase(jobListBireBirEslestir.pending, (state, action)=> {
      state.isLoadingJobListBireBirEslestir = true
      state.lastJobListAssignmentMode = action.meta.arg.driverAssignmentMode ?? 0
    })
    .addCase(jobListBireBirEslestir.fulfilled, (state, action)=> {
        state.isLoadingJobListBireBirEslestir = false
        const gunlukAracId = action.payload?.data?.gunlukAracId ?? action.meta.arg.gunlukAracId
        state.gunlukAracList = state.gunlukAracList.filter((item) => item.id !== gunlukAracId)
        // state.yukBekleyenAracCheckedItemList=[]
        // state.aracBekleyenYukCheckedItem=null
    })
    .addCase(jobListBireBirEslestir.rejected, (state)=> {
        state.isLoadingJobListBireBirEslestir = false
        state.errorUpdateList = true
    })


    .addCase(sendMail.pending, (state)=> {
      state.isLoadingSendMail = true
    })

    .addCase(sendMail.fulfilled, (state, action)=> {
      state.isLoadingSendMail = false
    })

    .addCase(sendMail.rejected, (state)=> {
      state.isLoadingSendMail = false
    })

    .addCase(jobListBireBirVeyaBireCokTeklifGonder.pending, (state)=> {
      state.isLoadingJobListBireBirVeyaBireCokTeklifGonder = true
    })
    .addCase(jobListBireBirVeyaBireCokTeklifGonder.fulfilled, (state, action)=> {
        state.isLoadingJobListBireBirVeyaBireCokTeklifGonder = false
        state.yukBekleyenAracCheckedItemList=[]
        state.aracBekleyenYukCheckedItem=null
        const { surucuList, yukId } = action.payload.data
        state.gunlukAracList = state.gunlukAracList.map(item => {
          const updatedItem = surucuList.$values.find(innerItem => innerItem.gunlukAracId === item.id)
          if(updatedItem){
            return {
              ...item, sendedLoadIdNotifications: [...item.sendedLoadIdNotifications, {loadId: yukId, sendedDate: updatedItem.sendedDate}]
            }
          }
          else{
            return item
          }
        })
    })
    .addCase(jobListBireBirVeyaBireCokTeklifGonder.rejected, (state)=> {
        state.isLoadingJobListBireBirVeyaBireCokTeklifGonder = false
        state.yukBekleyenAracCheckedItemList=[]
        state.aracBekleyenYukCheckedItem=null
        state.errorUpdateList = true
    })

    .addCase(jobListCokluTeklifGonder.pending, (state)=> {
      state.isLoadingJobListCokluTeklifGonder = true
    })
    .addCase(jobListCokluTeklifGonder.fulfilled, (state, action)=> {
        state.isLoadingJobListCokluTeklifGonder = false
        state.yukBekleyenAracCheckedItemList=[]
        state.aracBekleyenYukCheckedItem=null

        const list = action.payload.data.$values
        state.gunlukAracList = state.gunlukAracList.map(item => {
          const updatedItem = list.find(innerItem => innerItem.gunlukAracId === item.id) 
          if(updatedItem){
            return {...item, sendedLoadIdNotifications: updatedItem.sendedLoadIdNotifications.$values.map(updatedItem => {
              return {loadId: updatedItem.loadId, sendedDate: updatedItem.sendedDate}
            })}
          }
          else{
            return item
          }
        })
    })
    .addCase(jobListCokluTeklifGonder.rejected, (state)=> {
        state.isLoadingJobListCokluTeklifGonder = false
        state.yukBekleyenAracCheckedItemList=[]
        state.aracBekleyenYukCheckedItem=null
        state.errorUpdateList = true
    })
//! *****************************************************************************************************************

    .addCase(addNewDevamliDriver.pending, (state)=> {
      state.isLoadingAddNewDevamliDriver = true
    })
    .addCase(addNewDevamliDriver.fulfilled, (state, action)=> {
        state.isLoadingAddNewDevamliDriver = false
        state.isNewDriverStatus = true
        state.isNewDriverData = action.payload

    })
    .addCase(addNewDevamliDriver.rejected, (state)=> {
        state.isLoadingAddNewDevamliDriver = false
    })
    
    
  }
});

export const {
  setErrorMessage, 
  setShowNewCar, 
  clearVehicleRegisteredUser, 
  deleteVehicleRegisteredUser, 
  addVehicleRegisteredUser, 
  multipleCitySelectArray, 
  setAddVehicleFromDevamliAraclar, 
  setIsUserToDevamliArac, 
  setDevamliAraclarAldigiIsListeleme, 
  deleteDevamliAraclarPlaka, 
  setGunlukAraclarValues, 
  setCleanGunlukAraclarFilterValues, 
  setDevamliAracInfoForDelete, 
  setCleanDevamliAracFilter, 
  clearCheckedData, 
  resetVehicleClaimEligibleDrivers,
  setYukBekleyenAracCheckedItemList, 
  setJobListActiveActionId, 
  setDevamliAraclarIsListesiListeleme, 
  setDevamliAraclarSiraListesiListeleme, 
  setDevamliAraclarKayitliArac, 
  clearSearchArea, 
  clearVehicleList, 
  clearDailyList, 
  setDevamliAraclarValues, 
  setSelectedDevamliArac, 
  handleFrameState, 
  setYukBekleyenAracCheckedItem, 
  setAracBekleyenYukCheckedItem, 
  setUpdatedDevamliAracPlaka, 
  getMektupData, 
  restoreGumrukAssignmentContext,
  updateDevamliAraclarPlaka, 
  addDevamliAraclarPlaka, 
  multipleSrcSelectUpdate, 
  multipleEhliyetSelectUpdate, 
  setAllDataForDevamliArac, 
  setUpdatedDevamliArac, 
  setUpdateActive, 
  setSelectedPlateNumber, 
  setSelectedTrailerPlateNumber,
  getDevamliAracItem, 
  updateVehicle, 
  updateKasaTypeOptions, 
  setFormActiveStep, 
  setControlArea, 
  updateDailyVehicleList, 
  multipleCitySelect, 
  multipleRegionSelect, 
  clearJobListWithoutGunlukAraclar, 
  setRegisteredUser, 
  multipleEhliyetSelect, 
  multipleSrcSelect,
  setIsForGunlukArac,
  clearJobListWithoutGunlukAraclarAndSearch
} = jobListSlice.actions

export default jobListSlice.reducer;
